import { ZervantSettingsValues } from '@features/invoicingSettings/types/zervantSettingsValues'
import { getPrimaryTradeName } from '@features/invoicingSettings/utils/getPrimaryTradeName'

export const getDefaultTradeNameLogoId = (values: ZervantSettingsValues | undefined): string | undefined =>
  getPrimaryTradeName(values?.company.tradeNames)?.logo?.id
